import { Button } from "../ui/Button"
import { Dialog, DialogContentSize, DialogProps } from "@/components/ui/Dialog"
import { popDialog } from "@/store/dialogs-state"
import { toSnakeCase } from "@/utils/string"
import { ReactNode } from "react"

export interface ButtonContent {
	title: string
	trackingLabel?: string
	isDestructive?: boolean
	handler?: () => void
	disablePopDialog?: boolean
}

export type ImageStyle = "full" | "fit"

interface ConfirmContent {
	title?: string
	message?: string
	embeddedComponent?: ReactNode
	primary?: ButtonContent
	secondary?: ButtonContent
	imageSource?: string
	imageStyle?: ImageStyle
	canClose?: boolean
	trackingViewName: string
	className?: string
	contentSize?: DialogContentSize
}

export interface ConfirmDialogProps extends ConfirmContent {
	confirmResult?: (boolean) => void
	onFinish?: () => void
}

export function ConfirmDialog(props: ConfirmDialogProps & DialogProps) {
	const renderButton = (buttonContent: ButtonContent, isPrimary = false) => {
		return (
			<Button
				trackingLabel={buttonContent.trackingLabel ?? toSnakeCase(buttonContent.title)}
				onClick={() => {
					if (!buttonContent.disablePopDialog) {
						popDialog()
					}
					props.confirmResult?.(isPrimary)
					buttonContent.handler?.()
					props.onFinish?.()
				}}
				variant={
					buttonContent.isDestructive ? "destructive" : isPrimary ? "primary" : "default"
				}
			>
				{buttonContent.title}
			</Button>
		)
	}

	return (
		<Dialog
			trackingViewName={props.trackingViewName}
			disableClose={props.canClose != true}
			onOpenChange={(open) => {
				if (!open) {
					props.onFinish?.()
				}
				//TODO: add close confirm
			}}
			contentSize={props.contentSize ?? "sm-h-auto"}
		>
			<div className={`flex h-fit w-full flex-col space-y-3 ${props.className ?? ""}`}>
				{props.imageSource && props.imageStyle === "full" && (
					<div className="w-full overflow-visible">
						<img
							className="ml-[-24px] mt-[-24px] object-fill pb-3"
							src={props.imageSource}
						/>
					</div>
				)}
				{props.imageSource && props.imageStyle === "fit" && (
					<img className="w-1/3 self-center object-cover" src={props.imageSource} />
				)}
				{props.title && <div className="text-start text-md font-bold">{props.title}</div>}
				{props.message && <div className="pb-2 text-start text-sm">{props.message}</div>}
				{props.embeddedComponent ? props.embeddedComponent : undefined}

				<div className="flex w-full flex-1 flex-row items-center justify-end space-x-2">
					{props.secondary && renderButton(props.secondary)}
					{props.primary && renderButton(props.primary, true)}
				</div>
			</div>
		</Dialog>
	)
}
